if($('body.post-1 .js-h1-substitutions').length){
    text_to_change = $('.js-changing-title');
    text_options = $('.js-h1-substitutions');

    setInterval(function(){
        key = text_to_change.data('key');
        key++;

        if( !$('span[data-key="'+ key +'"]', text_options ).length){
            key = 0;
        }
        text_to_change.fadeOut(function(){
            let new_text = $('span[data-key="'+ key +'"]', text_options).text();
            text_to_change.text(new_text);
            $(this).fadeIn();
        })
        text_to_change.data('key', key);
    }, 2500);
}
